import { createTheme } from '@mui/material/styles';
import { red, grey, common } from '@mui/material/colors';

const MuiComponents= {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 8, // Custom border radius for all Input fields
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      outlined: {
        borderRadius: 8, // Custom border radius for Select fields
        fontSize:14,
      },
      root: {
      '& .MuiInputLabel-root': {
          transform: 'translate(10px, 12px)', // Adjust label position
          fontSize: '14px',  // Adjust label font size
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(10px, -8px) scale(0.78)', // Adjust label position when focused
          fontSize: '14px',
        },
      }
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputBase-root': {
          height: '45px', // Custom global input height
          fontSize: '12px', // Custom global font size
          padding: '0 0px',
        },
        '& .MuiInputLabel-root': {
          transform: 'translate(10px, 12px)', // Adjust label position
          fontSize: '14px',  // Adjust label font size
        },
        '& .MuiInputLabel-shrink': {
          transform: 'translate(10px, -8px) scale(0.78)', // Adjust label position when focused
          fontSize: '14px',
        },
      },
    },
    
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft:3,
        marginTop:0,
        fontSize: '12px', 
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }:any) => ({
        backgroundColor: theme.palette.mode === 'dark' 
        ? theme.palette.background.paper 
        : theme.palette.background.default, // Use theme-aware colors
        paddingRight: '5px',
        fontSize:14
      }),
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1)', // Custom box shadow
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        // Add custom styles here
        borderRadius: '50%', // Makes the Checkbox more rounded
      },
    },
  },

  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: '"DM Sans", "Arial", sans-serif',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 7, // Set your desired border radius
      },
    },
  },

  MuiAlert: {
    styleOverrides: {
      filledSuccess: {
        backgroundColor: '#14A44D', // Custom background for success
      },
      filledError: {
        backgroundColor: '#E53935', // Custom background for success
      },
    }
  }
}



// Extend the theme to include our custom colors
declare module '@mui/material/styles' {
  interface Palette {
    banned: Palette['primary'];
    pending: Palette['primary'];
    active: Palette['primary'];
  }
  interface PaletteOptions {
    banned: PaletteOptions['primary'];
    pending: PaletteOptions['primary'];
    active: PaletteOptions['primary'];
  }
}



// Light Theme
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3660f9',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: common.white,
      paper: common.white,
    },
    text: {
      primary: '#000000',
    },
    banned: {
      main: '#ff0500',
      contrastText: '#ffffff',
    },
    pending: {
      main: '#ff9800',
      contrastText: '#ffffff',
    },
    active: {
      main: '#00bf09',
      contrastText: '#ffffff',
    },
  },
  components:MuiComponents,
  typography: {
    fontFamily: '"DM Sans"',
    h1: { fontWeight: 800,  },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 300 },
  },
});

// Dark Theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3660f9',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: grey[900],
      paper: common.black,
    },
    text: {
      primary: '#ffffff',
    },

    banned: {
      main: '#ff0500',
      contrastText: '#ffffff',
    },
    pending: {
      main: '#ff9800',
      contrastText: '#ffffff',
    },
    active: {
      main: '#00bf09',
      contrastText: '#ffffff',
    }

    
  },
  components:MuiComponents,
  typography: {
    fontFamily: '"DM Sans", "Arial", sans-serif',
    h1: { fontWeight: 800,  },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 300 },
  },
});

export { lightTheme, darkTheme };

